$(function () {
    if (typeof google === "undefined") return;

    google.maps.event.addDomListener(window, 'load', function () {
        var input = document.getElementById('address');
        new google.maps.places.Autocomplete(input);
    });
});
